import { render, staticRenderFns } from "./ClientCreateEdit.vue?vue&type=template&id=d64affbe&scoped=true"
import script from "./ClientCreateEdit.vue?vue&type=script&lang=js"
export * from "./ClientCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./ClientCreateEdit.vue?vue&type=style&index=0&id=d64affbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64affbe",
  null
  
)

export default component.exports